export default class ApiCancelError implements Error {
  public name = 'ApiCancelError';
  constructor(public message: string) {}
}
